module.exports = __webpack_public_path__ + "media/images/secure-b628da257ab7e119fb37462980e76e57.svg";